import { FormListProviderWrapper } from 'core';
import { useUserData } from 'core/Api';
import { Affix, Modal, Stack } from 'ui';

import { EditProfileForm } from './EditProfileForm';
import { EditProfileImage } from './EditProfileImage';
import { SaveProfileButton } from './SaveProfile';

const EditProfileContent = ({ handleClose }: { handleClose: () => void }) => {
  const { data: user, isFetched } = useUserData();

  return (
    <>
      <Stack px={'lg'}>
        <Stack>
          {isFetched && <EditProfileImage logoUrl={user?.logo?.url} />}
          {user && <EditProfileForm user={user} />}
        </Stack>
      </Stack>
      <Affix
        w="100%"
        withinPortal={false}
        p={'lg'}
        pt={'xl'}
        bg="linear-gradient(to bottom, rgba(255, 255, 255, 0.3), rgba(255, 255, 255, 1) 50%)"
        style={{ position: 'sticky' }}
      >
        <SaveProfileButton onClose={handleClose} />
      </Affix>
    </>
  );
};

const EditProfileModal = ({ opened, onClose }: { opened: boolean; onClose: () => void }) => {
  return (
    <Modal opened={opened} onClose={onClose} title="Edit Profile" styles={{ body: { padding: 0 } }}>
      <FormListProviderWrapper>
        <EditProfileContent handleClose={onClose} />
      </FormListProviderWrapper>
    </Modal>
  );
};

export { EditProfileModal };
